import { Button, Result } from "antd";
import { getCookie, setCookie } from "./CookieHelpers";
import React from "react";

const ErrorPage = ({ expirationMinutes }) => {
    const bypassLogin = getCookie("login_type") === "BYPASS";

    const onClick = () => {
        const redirect = bypassLogin ? "/login" : "/logout";
        setCookie("login_type", null, expirationMinutes);
        setCookie("user_email", null, expirationMinutes);
        setCookie("pas", null, expirationMinutes);
        setCookie("user_password", null, expirationMinutes);
        setCookie("user_token", null, expirationMinutes);
        localStorage.clear();
        window.location.replace(redirect);
    };

    return (
        <>
            <Result
                style={{ marginTop: "8%" }}
                status="403"
                title="Your log in has timed out..."
                subTitle='Your session has expired. Please click "Clear Session" below to reset your session and log in again. If the issue persists, contact the support team at cash_bts_support@abbvie.com for assistance.'
                extra={<Button type="primary" onClick={onClick}>Clear Session</Button>}
            />
        </>
    );
}

export default ErrorPage;